<div class="page-overlay" *ngIf="isBusy">
  <div class="center">
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>
<mat-dialog-content class="mat-typography">
  
  <h1 mat-dialog-title>Neues Projekt anlegen</h1>
  
  <app-cs-project-form #projectForm [isReadonly]=false></app-cs-project-form>
   
  <mat-error *ngIf="error">{{error}}</mat-error>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="discardChanges()">Abbrechen</button>
  <button mat-button cdkFocusInitial [disabled]="!projectForm.isValid" (click)="saveChanges()">Erstellen</button>
</mat-dialog-actions>